module.exports = __webpack_public_path__ + "static/reward.a2d961e4.png";